<template>
  <lite-youtube
    class="w-full rounded-xl"
    :videoid="videoid"
    :params="params"
    :aria-label="ariaLabel"
    :style="style"
  />
</template>
<script lang="ts">
export default { name: 'LiteYouTubeWrapper' }
</script>

<script setup lang="ts">
// @see src/templates/_components/tag/video.twig for why this component is needed
withDefaults(defineProps<{
  videoid: string,
  ariaLabel?: string,
  params?: string,
  style?: object,
}>(), {
  ariaLabel: '',
  style: '',
  params: 'rel=0&amp;theme=light',
})
</script>
